import { Language } from '../data/content'

/** Formats a service duration in minutes as a short, human label per language. */
export function formatDuration(minutes: number, lang: Language): string {
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60

  if (lang === 'es') {
    const hourPart = hours > 0 ? `${hours} h` : ''
    const minutePart = rest > 0 ? `${rest} min` : ''
    return [hourPart, minutePart].filter(Boolean).join(' ')
  }

  const hourPart = hours > 0 ? `${hours} ${hours === 1 ? 'hr' : 'hrs'}` : ''
  const minutePart = rest > 0 ? `${rest} mins` : ''
  return [hourPart, minutePart].filter(Boolean).join(' ')
}
